import {
    initSentryClient,
} from '@pb/services';

initSentryClient({
    dsn: 'https://32a22c217f9b48c2aff8a3fb9ae2c38d@o575218.ingest.sentry.io/4504055974723584',
});
